var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#ff9300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "game_controller_round [#ff9300]"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-420.000000, -4679.000000)",
    fill: "#ff9300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382,4528 C382,4527.448 381.552,4527 381,4527 L367,4527 C366.448,4527 366,4527.448 366,4528 L366,4536 C366,4536.552 366.448,4537 367,4537 L369,4537 C369.552,4537 370,4536.552 370,4536 C370,4535.448 370.448,4535 371,4535 L377,4535 C377.552,4535 378,4535.448 378,4536 C378,4536.552 378.448,4537 379,4537 L381,4537 C381.552,4537 382,4536.552 382,4536 L382,4528 Z M384,4527 L384,4537 C384,4538.105 383.105,4539 382,4539 L378,4539 C376.895,4539 376,4538.105 376,4537 L372,4537 C372,4538.105 371.105,4539 370,4539 L366,4539 C364.895,4539 364,4538.105 364,4537 L364,4527 C364,4525.895 364.895,4525 366,4525 L373,4525 L373,4523 C373,4521.895 373.895,4521 375,4521 L377,4521 C377.552,4521 378,4520.552 378,4520 L378,4519 L380,4519 L380,4521 C380,4522.105 379.105,4523 378,4523 L376,4523 C375.448,4523 375,4523.448 375,4524 L375,4525 L382,4525 C383.105,4525 384,4525.895 384,4527 L384,4527 Z M379,4529 L377,4529 C376.448,4529 376,4529.448 376,4530 L376,4531 L376,4532 C376,4532.552 376.448,4533 377,4533 L379,4533 C379.552,4533 380,4532.552 380,4532 L380,4531 L380,4530 C380,4529.448 379.552,4529 379,4529 L379,4529 Z M372,4530 L372,4531 L372,4532 C372,4532.552 371.552,4533 371,4533 L369,4533 C368.448,4533 368,4532.552 368,4532 L368,4531 L368,4530 C368,4529.448 368.448,4529 369,4529 L371,4529 C371.552,4529 372,4529.448 372,4530 L372,4530 Z",
    id: "game_controller_round-[#ff9300]"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.a859b1f710c94f802f8635620249cd87.svg";
export { ForwardRef as ReactComponent };